import React, { useRef, useEffect } from 'react';
import paper from 'paper';

const Tangle = () => {
  const canvasRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    paper.setup(canvasRef.current);

    // Create a random path with segments
    const pathData = [];
    for (let i = 0; i < 20; i++) {
      pathData.push(new paper.Point(Math.random() * paper.view.size.width, Math.random() * paper.view.size.height));
    }

    const path = new paper.Path({
      segments: pathData,
      closed: true,
      fillColor: 'transparent',
      strokeColor: 'black',
      strokeWidth: 5,
      mixedBlendMode: 'difference',
    });

    pathRef.current = path;

    const onMouseMove = (event) => {
      if (pathRef.current) {
        const mousePoint = event.point;
        const nearestSegment = pathRef.current.getNearestLocation(mousePoint).segment;

        // Calculate a random shift to apply to the nearest segment
        const randomShift = new paper.Point(Math.random() * 20 - 10, Math.random() * 20 - 10);

        nearestSegment.point = nearestSegment.point.add(randomShift);
      }
    };

    paper.view.on('mousemove', onMouseMove);

    return () => {
      paper.view.off('mousemove', onMouseMove);
      paper.project.clear();
    };
  }, []);

  return <canvas ref={canvasRef} style={{ width: '100%', height: '100%' }} />;
};

export default Tangle;
